import { API_BASE_URL } from "../constant/api";
import { clearAdminSession, getAdminToken, setSessionExpiredNotice } from "./auth";

const parseJsonSafely = async (response) => {
  const raw = await response.text();

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    throw new Error("The server returned an invalid response.");
  }
};

export const apiRequest = async (path, options = {}) => {
  const { skipSessionExpiryHandling = false, ...fetchOptions } = options;
  const token = getAdminToken();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(fetchOptions.headers || {})
    },
    ...fetchOptions
  });

  const payload = await parseJsonSafely(response);

  if (!response.ok) {
    if (
      response.status === 401 &&
      !skipSessionExpiryHandling &&
      path !== "/api/auth/login"
    ) {
      const message = payload?.message || "Your login session has expired. Please sign in again.";
      setSessionExpiredNotice(message);
      clearAdminSession();

      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("admin-session-expired", {
            detail: { message }
          })
        );
      }
    }

    const error = new Error(payload?.message || "Request failed");
    if (typeof payload?.retryAfterSeconds === "number") {
      error.retryAfterSeconds = payload.retryAfterSeconds;
    }
    throw error;
  }

  return payload;
};

export const uploadFile = async (path, file, fields = {}, fileField = "image") => {
  const token = getAdminToken();
  const formData = new FormData();
  formData.append(fileField, file);
  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    credentials: "include",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: formData
  });

  const payload = await parseJsonSafely(response);

  if (!response.ok) {
    throw new Error(payload?.message || "Upload failed");
  }

  return payload;
};
